<template>
    <div class="row cards-list carousel-card-list test">
        <course-card
               v-for="item in coursesList"
               :course="item"
               :corporation="corporation"
               @enroll="doEnroll"
               @wait-list="doWaitList"
               :key="item.id"
               :forSlider="true">
        </course-card>
    </div>
</template>

<script>
import CourseCard from '@/components/CourseCardV2';

export default {
    name: "CoursesSlider",
    props: {
        coursesList: {
            type: Array
        },
        corporation: {
            type: Object
        }
    },
    components: {
        CourseCard
    },
    mounted: function () {
        //Init slider
        $(this.$el).slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ],
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">\n' +
                '    <i class="icon-left"></i>\n' +
                '</button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button">\n' +
                '    <i class="icon-right"></i>\n' +
                '</button>'
        });
    },
    methods: {
        doEnroll(courseId) {
            this.$emit('enroll', courseId);
        },
        doWaitList(courseId) {
            this.$emit('wait-list', courseId);
        }

    }
}
</script>

<style scoped>

</style>
